module.exports = __webpack_public_path__ + "static/media/scan.44426c85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/scan.svg
// module id = 186
// module chunks = 0